export enum LinkStatus {
  Accepted = 'Accepted',
  Proposal = 'Proposal',
  Rejected = 'Rejected',
}
